// Mirror dari lotus-be-express/src/modules/livechat/constants/livechat.constants.ts — jaga tetap sinkron.

// DEV-1193/1197 — brand "reserved" khusus channel mitra<->purchasing. `listBrands()` sudah
// difilter per-role di backend (`filterBrandsForRole`), jadi kemunculan brand ini di daftar brand
// milik staff yang login = sinyal cukup untuk menampilkan menu "Daftar Kontak" (DEV-1197) tanpa
// perlu expose role mentah staff ke frontend.
export const LIVECHAT_PARTNER_BRAND = "mitra-purchasing";

// DEV-1227 — mirror CORPORATE_BRAND (lotus-be-express/src/modules/livechat/utils/corporateAccess.util.ts).
// AC DEV-1222: tanda customer/insight ini tampil "dari layanan manapun SELAIN Corporate" -
// channel Corporate punya kebutuhan/tampilan sendiri (BSR-94), di luar cakupan tiket ini.
export const CORPORATE_BRAND = "corporate";

// Asumsi #3 PRD DEV-1190 ("batas ukuran mengikuti batas wajar aplikasi chat, mis. maks ~25MB") —
// HARUS tetap sinkron dgn LIVECHAT_MAX_UPLOAD_SIZE_MB di
// lotus-be-express/src/middlewares/livechatUpload.middleware.ts (sumber kebenaran, ini cuma
// duplikat utk validasi cepat di client sebelum upload — server tetap yang menegakkan batasnya).
export const LIVECHAT_MAX_UPLOAD_SIZE_MB = 25;

export const LEAD_TYPES = ["Sulit Closing", "Sedang", "Mudah Closing"];
export const GENDERS = ["Male", "Female"];

export const OCCASIONS = [
    "Ulang Tahun", "Anniversary", "Kelahiran Bayi", "Wisuda", "Grand Opening",
    "Promosi Jabatan", "Hari Valentine", "Hari Ibu/Ayah", "Natal/Tahun Baru",
    "Imlek/Lebaran", "Kejutan Romantis", "Ucapan Semangat", "Cepat Sembuh", "Ucapan Duka Cita",
];

export const REASON_GROUPS = {
    Customer: [
        "Perubahan keputusan pribadi",
        "Acara dibatalkan atau diundur",
        "Tidak ada niat awal membeli (leads dingin)",
        "Hanya mencari informasi atau perbandingan",
        "Salah memahami produk atau fitur layanan",
    ],
    Harga: [
        "Harga terlalu mahal",
        "Harga kompetitor lebih murah",
        "Tidak ada promo atau diskon menarik",
        "Anggaran tidak mencukupi",
        "Tidak sesuai dengan ekspektasi nilai/manfaat",
    ],
    Lokasi: [
        "Lokasi Customer di luar jangkauan layanan",
        "Alamat sulit dijangkau oleh kurir",
        "Area tidak tersedia di pengiriman",
        "Lokasi toko jauh dari alamat customer",
        "Zona geografis berisiko atau tidak sesuai",
    ],
    Ongkir: [
        "Ongkos kirim terlalu mahal",
        "Tidak tersedia opsi pengiriman ekonomis",
        "Biaya tambahan tidak disetujui pelanggan",
    ],
    Payment: [
        "Metode pembayaran tidak sesuai",
        "Gangguan sistem pembayaran",
        "Transaksi gagal secara teknis",
    ],
    Product: [
        "Produk habis (out of stock)",
        "Produk tidak sesuai ekspektasi (desain/warna)",
        "Kualitas produk diragukan",
        "Estimasi pengerjaan/pengiriman terlalu lama",
    ],
    Random: [
        "Alasan insidental unik",
        "Pembatalan tanpa penjelasan jelas",
    ],
    Sales: [
        "Respons sales lambat",
        "Informasi dari sales kurang jelas",
        "Terjadi miskomunikasi sales-pelanggan",
        "Sales tidak sesuai SOP",
    ],
    Tagline: [
        "Klik tagline tanpa minat beli",
        "Klik dilakukan tidak sengaja",
        "Tidak ada tindak lanjut setelah klik",
    ],
    Visit: [
        "Batal datang ke toko",
        "Jadwal kunjungan berubah",
        "Tidak ada konfirmasi dari pelanggan",
        "Pelanggan ingin beli offline",
    ],
};

export const QUICK_LABELS = [
    { label: "Komplain Keterlambatan", color: "#FA8072" }, // Salmon
    { label: "Komplain Produk Tidak Sesuai", color: "#FFC0CB" }, // Pink
    { label: "Komplain Layu/Rusak", color: "#9370DB" }, // Ungu
    { label: "Komplain Pesanan Tidak Dibuatkan", color: "#8B5E3C" }, // Coklat
    { label: "Komplain Laporan", color: "#4B0082" }, // Indigo
    { label: "Konfirmasi Pesanan", color: "#4169E1" }, // Biru
    { label: "Lain-lain", color: "#008080" }, // Teal
    { label: "Laporan", color: "#FFA500" }, // Oranye
];

export const MAIN_LABELS = ["pending", "cancel", "paid", "unpaid"];
export const RANDOM_LABEL = "random";

// Field form yang tampil (dan wajib diisi) per label utama — pending/cancel butuh form lengkap,
// paid/unpaid cuma butuh sebagian field (lihat SetLabelDialog.jsx).
export const MAIN_LABEL_FIELDS = {
    pending: ["leadType", "productCategory", "deliveryDate", "city", "gender", "occasion", "reasonGroup", "reason"],
    cancel: ["leadType", "productCategory", "deliveryDate", "city", "gender", "occasion", "reasonGroup", "reason"],
    paid: ["productCategory", "city"],
    unpaid: ["productCategory", "city", "deliveryDate"],
};
